// ABOUTME: API client for personas endpoints
// ABOUTME: Fetches persona definitions and metrics

import { apiClient } from './client';

export interface PersonaDefinition {
  persona_type: string;
  persona_code: string;
  description: string;
  identifying_attributes: string[];
  signal_phrases: string[];
  typical_constraints: string[];
  typical_goals: string[];
  key_differentiators: Record<string, string>;
  active: boolean;
  version: string;
}

export interface PersonaMetrics {
  persona_type: string;
  learner_count: number;
  interview_count: number;
  avg_confidence: number;
}

export interface PersonasResponse {
  definitions: PersonaDefinition[];
  metrics: PersonaMetrics[];
  total_classified: number;
  total_learners: number;
  classification_rate: number;
}

export const personasApi = {
  async getPersonas(): Promise<PersonasResponse> {
    const response = await apiClient.get('/api/personas');
    return response.data;
  },
};
